module.exports = __webpack_public_path__ + "images/mobile6fdfa59b1a9a142607d566e5c2ef42f8.png";